// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
import Vue from 'vue';
import App from './App';
import router from './router';
import VConsole from 'vconsole';
import { VueBus } from './lib/common';
import es6Promise from 'es6-promise';
import request from './lib/request';
import gameRequest from './lib/game-request';
import sdk from './lib/sdk';
import share from './lib/share';
import ModalWarpper from './modules/modal';
import IconSelf from './modules/icon';
import WelfareTaskMixin from '@/mixins/WelfareTaskMixin';
import methods from './root/index';
import VueAnimateNumber from 'vue-animate-number';

// 引入vuex
import store from './store';

// 引入全局样式文件
import './css/base.css';
import './css/border.css';
import './css/global-component.less';

// 新增全局组件模块
import GlobalComponent from '@/components/common';
import plugins from '../src/components/common/JdFinanceBottomPopup';
// 新增全局请求方法
import $http from './service/request';

// 重构sdk模块
import sdkNew from '@/sdk';

Vue.config.ignoredElements = ['wx-open-launch-weapp'];

Vue.use(VueAnimateNumber);
// 注册全局组件
Vue.use(GlobalComponent);
Vue.use(plugins);
// 给 Vue 添加全局原型方法
Vue.use($http);

// 添加全局sdk调用方法
Vue.prototype.$sdkNew = sdkNew;

Vue.use(ModalWarpper);
Vue.use(IconSelf);

import './lib/shimming';
import {
	compatiblePreloadVideo,
	compatibleShowVideo,
	compatibleOpenQQQun,
	compatibleOpenYueMeng,
	compatibleOpenMgcGame,
} from './lib/compatible';
if (!window.Promise) {
	es6Promise.polyfill();
}

import { Swipe, SwipeItem } from 'vant';
import { Icon } from 'vant';
import { List } from 'vant';
import { PullRefresh } from 'vant';
import { Checkbox, CheckboxGroup } from 'vant';
import { Progress } from 'vant';
import { Cell, CellGroup } from 'vant';
import { Form } from 'vant';
import { Field } from 'vant';
import { Button } from 'vant';
import { Calendar } from 'vant';
import { Tab, Tabs } from 'vant';
import { Overlay } from 'vant';
import { Switch } from 'vant';
import { Loading } from 'vant';
import { CountDown } from 'vant';
import { Popup } from 'vant';
import { Picker } from 'vant';
import { Popover } from 'vant';
import { grid } from 'vant';
import { Step, Steps } from 'vant';
import { Skeleton } from 'vant';
import { Empty } from 'vant';
import { ActionSheet } from 'vant';
import { Toast } from 'vant';
import { Lazyload } from 'vant';
import { Slider } from 'vant';
import { NoticeBar } from 'vant';
import { Search } from 'vant';
import { Circle } from 'vant';
import { Cascader } from 'vant';
import { Dialog as vantDialog } from 'vant';

Vue.use(Skeleton);
Vue.use(Empty);
Vue.use(ActionSheet);
Vue.use(Toast);
Vue.use(Picker);
Vue.use(Popup);
Vue.use(Loading);
Vue.use(Switch);
Vue.use(Overlay);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Button);
Vue.use(Field);
Vue.use(Form);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Progress);
Vue.use(Checkbox).use(CheckboxGroup);
Vue.use(PullRefresh);
Vue.use(List);
Vue.use(Icon);
Vue.use(Swipe).use(SwipeItem);
Vue.use(Calendar);
Vue.use(CountDown);
Vue.use(Popover);
Vue.use(grid);
Vue.use(Step);
Vue.use(Steps);
Vue.use(Slider);
Vue.use(NoticeBar);
Vue.use(Search);
Vue.use(Circle);
Vue.use(Cascader);
Vue.use(vantDialog);

Vue.use(Lazyload, {
	lazyComponent: true,
});

/**
 * 此段代码为手动按需引用 kuaiyin-ui 组件
 * 取别名是为了不与 vant 组件变量冲突
 * */
import { default as KyButton } from 'kuaiyin-ui/lib/button';
import 'kuaiyin-ui/lib/style/button.css';
import Dialog from 'kuaiyin-ui/lib/dialog';
import 'kuaiyin-ui/lib/style/dialog.css';
import Grid from 'kuaiyin-ui/lib/grid';
import 'kuaiyin-ui/lib/style/grid.css';
import GridItem from 'kuaiyin-ui/lib/grid-item';
import 'kuaiyin-ui/lib/style/grid-item.css';

const list = [KyButton, Dialog, Grid, GridItem];

list.forEach((item) => {
	Vue.use(item);
});

Vue.config.productionTip = false;
// 引入iconfont
import './assets/iconfont/iconfont.js';
import './assets/iconfont/iconfont-fangbo';
import './assets/iconfont/iconfont.css';
import './components/game/common-component/svg-icon/index';
// 全局注册
Vue.prototype.$axios = request;
Vue.prototype.$gameAxios = gameRequest;
Vue.prototype.$sdk = sdk;
Vue.prototype.$sdk.share = share;
Vue.prototype.$compatible = {
	compatiblePreloadVideo,
	compatibleShowVideo,
	compatibleOpenQQQun,
	compatibleOpenYueMeng,
	compatibleOpenMgcGame,
};
function setFontSize() {
	const doc = window.document;
	const $html = doc.getElementsByTagName('html')[0];
	const windowWidth = doc.documentElement.clientWidth || doc.body.clientWidth || window.innerWidth;
	window.fsize = windowWidth / 3.75;
	$html.style.fontSize = window.fsize + 'px';
}
setFontSize();
window.onresize = setFontSize;
Vue.use(VueBus);

const info = window.bridge && window.bridge.getUserInfo();
let uid;
if (info) {
	const client = JSON.parse(info);

	uid = client.uid;
}
if (process.env.NODE_ENV !== 'production' || +uid === 27886173 || +uid === 26590388 || +uid === 18412121 || +uid === 186720444) {
	new VConsole();
}

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	store,
	components: { App },
	mixins: [WelfareTaskMixin],
	template: '<App/>',
	created() {
		this.initStore();
	},
	methods,
});



// WEBPACK FOOTER //
// ./src/main.js